import {
  useState,
  type FunctionComponent,
  type KeyboardEvent,
  type MouseEvent,
  type PropsWithChildren,
} from 'react';
import './styles.css';

const ReadMore: FunctionComponent<
  PropsWithChildren<{ trackElements: (content: string) => void }>
> = ({ children, trackElements }) => {
  const [isVisible, setIsVisible] = useState(false);
  const buttonText = isVisible ? 'Show less' : 'Show more';

  const handleShowLess = (e: KeyboardEvent<HTMLDivElement> | MouseEvent<HTMLDivElement>) => {
    const el = e.currentTarget.closest('button');
    if (el && e.currentTarget.contains(el)) {
      setIsVisible(false);
    }
  };

  const toggleVisibility = () => {
    setIsVisible((prevState) => !prevState);
    trackElements(buttonText);
  };

  return (
    <div className="read-more">
      {isVisible && (
        <div
          aria-hidden="true"
          onClick={handleShowLess}
          onKeyDown={handleShowLess}
          dangerouslySetInnerHTML={{ __html: children }}
        />
      )}
      <button type="button" onClick={toggleVisibility}>
        {buttonText}
      </button>
    </div>
  );
};

export default ReadMore;
